import React, { useEffect } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthenticationBoundary, ProtectedRoute } from "components/AuthenticationBoundary";
import ServiceStatusProvider, { useServiceRequest } from "components/ServiceStatusProvider";
import NotFound from "pages/NotFound";
import AdminLogin from './pages/admin-login';
import PriceGuidePage from './pages/price-guide';
import AdminTermsManagement from './pages/admin-terms-management';
import AdminCustomerManagement from './pages/admin-customer-management';
import AdminProductsManagement from './pages/admin-products-management';
import CustomerHome from './pages/customer-home';
import TermsAndConditions from './pages/terms-and-conditions';
import CleaningRequestForm from './pages/cleaning-request-form';
import OrderStatusTracking from './pages/order-status-tracking';
import AdminOrdersManagement from './pages/admin-orders-management';
import BeforeAfter from './pages/before-after';
import AdminBeforeAfterManagement from './pages/admin-before-after-management';

// 접수 중단 상태에서 /cleaning-request-form 직접 접근 시
// 홈으로 돌려보내고 안내 모달을 띄웁니다.
const CleaningRequestRoute = () => {
  const { ordersOpen, requestCleaning } = useServiceRequest();

  useEffect(() => {
    if (!ordersOpen) {
      requestCleaning();
    }
  }, [ordersOpen, requestCleaning]);

  if (!ordersOpen) {
    return <Navigate to="/customer-home" replace />;
  }

  return <CleaningRequestForm />;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthenticationBoundary>
        <ErrorBoundary>
          <ScrollToTop />
          <ServiceStatusProvider>
          <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<CustomerHome />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/before-after" element={<BeforeAfter />} />
            <Route path="/price-guide" element={<PriceGuidePage />} />
            <Route 
              path="/admin-terms-management" 
              element={
                <ProtectedRoute>
                  <AdminTermsManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin-customer-management" 
              element={
                <ProtectedRoute>
                  <AdminCustomerManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin-products-management" 
              element={
                <ProtectedRoute>
                  <AdminProductsManagement />
                </ProtectedRoute>
              } 
            />
            <Route path="/customer-home" element={<CustomerHome />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/cleaning-request-form" element={<CleaningRequestRoute />} />
            <Route path="/order-status-tracking" element={<OrderStatusTracking />} />
            <Route 
              path="/admin-orders-management" 
              element={
                <ProtectedRoute>
                  <AdminOrdersManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin-before-after-management" 
              element={
                <ProtectedRoute>
                  <AdminBeforeAfterManagement />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
          </ServiceStatusProvider>
        </ErrorBoundary>
      </AuthenticationBoundary>
    </BrowserRouter>
  );
};

export default Routes;